<div class="row">
  <div class="col-md-12">
      <app-sist-radnih-mesta-stavka-inline-update #baseInlineUpdate></app-sist-radnih-mesta-stavka-inline-update>      
  </div>
</div>
<div class="row">
  <div class="col-lg-12">
      <yt-fw-default-detail-list-inline 
      #baseDetailList
      [Model]="modelData.MainList.DetailList[0]" 
          [ParentPropertyName]="_parentPropertyName"
          [ParentPropertyValue]="_parentPropertyValue" 
          [Disabled]="!_parentPropertyValue || _parentPropertyValue <= 0"
          (Items)="setItems($event)">
      </yt-fw-default-detail-list-inline>
  </div>  
</div>